import {
  formatCurrency,
  formatPhone,
  toDateOnlyString,
  toTimeOnlyString,
  boolToYesNo,
  formatPercent,
  dayOfWeekString,
  formatDate,
  getExpenseTypeLabel,
  getPayFrequencyLabel,
  getPayRateTypeLabel,
  getBillRateTypeLabel,
  getInvoicingFrequencyLabel,
  getEmployeeTypeLabel,
  getContractTypeLabel,
  getDealAssignmentTypeLabel,
  getExpenseAmountType,
  formatDecimal
} from '@/lib/display'

import { getRoleLabel } from '@/lib/securityRoles'

const useFilters = (vueInstance) => {
  vueInstance.filter('currency', formatCurrency)
  vueInstance.filter('percent', formatPercent)
  vueInstance.filter('phone', formatPhone)
  vueInstance.filter('toDateOnlyString', toDateOnlyString)
  vueInstance.filter('toTimeOnlyString', toTimeOnlyString)
  vueInstance.filter('dayOfWeekString', dayOfWeekString)
  vueInstance.filter('boolToYesNo', boolToYesNo)
  vueInstance.filter('roleLabel', getRoleLabel)
  vueInstance.filter('formatDate', formatDate)
  vueInstance.filter('getExpenseTypeLabel', getExpenseTypeLabel)
  vueInstance.filter('getPayFrequencyLabel', getPayFrequencyLabel)
  vueInstance.filter('getPayRateTypeLabel', getPayRateTypeLabel)
  vueInstance.filter('getBillRateTypeLabel', getBillRateTypeLabel)
  vueInstance.filter('getInvoicingFrequencyLabel', getInvoicingFrequencyLabel)
  vueInstance.filter('getEmployeeTypeLabel', getEmployeeTypeLabel)
  vueInstance.filter('getContractTypeLabel', getContractTypeLabel)
  vueInstance.filter('getDealAssignmentTypeLabel', getDealAssignmentTypeLabel)
  vueInstance.filter('getExpenseAmountType', getExpenseAmountType)
  vueInstance.filter('formatDecimal', formatDecimal)
}

export default useFilters
